// extracted by mini-css-extract-plugin
export default {"placeholderSearchFormFilter":"placeholder-search-form-filter__placeholder-search-form-filter__WEyDp"};